export default __webpack_public_path__ + "static/media/html1.e78a1f6c.png";